import * as Sentry from '@sentry/react';

let sentryEnabled = false;

export function initSentry() {
  if (!import.meta.env.VITE_SENTRY_DSN) {
    console.log('[Sentry] DSN not set — client error tracking disabled');
    return;
  }

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 0.0,
  });

  sentryEnabled = true;
  console.log('[Sentry] Client-side error tracking enabled');
}

export function captureException(error: unknown, context?: Record<string, any>) {
  if (!sentryEnabled) return;
  Sentry.captureException(error, context ? { extra: context } : undefined);
}

export { Sentry };
